import { Divider, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
    Control,
    FieldErrors,
    UseFormRegister,
    UseFormReset,
    UseFormSetValue,
} from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { callAPI, dateFormat, IsSmallScreen, Method } from "../../../../commonFunctions/CommonFunctions";
import WSAutocompleteField from "../../../../Components/AutoComplete/AutoComplete";
import WSButton from "../../../../Components/Button/WSButton";
import WSSCheckBoxField from "../../../../Components/CheckBox/WSCheckBox";
import WSDateField from "../../../../Components/DateField/WSDateField";
import WSHiddenField from "../../../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../../../Components/Select/WSSelect";
import WSTextField from "../../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../../Components/WSTextArea/WSTextArea";
import WSTimePicker from "../../../../Components/WSTimePicker/WSTimePicker";
import config from "../../../../Config/clientConfig.json";
import { AppState } from "../../../../StateManagement/types";
interface TaskProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    taskId?: string;
    setValue: UseFormSetValue<any>;
    onCancel: () => void
    data?: any,
    loading: boolean,
    isDisableUser?: boolean
}

const TaskAssign: React.FC<TaskProps> = ({
    control, id, register, taskId, reset, setValue, onCancel, data, isDisableUser = false
}) => {

    const [loading, setLoading] = useState(false);
    const [activityDate, setActivityDate] = useState<any>(undefined);
    const [isReminder, setIsReminder] = useState(false);
    const isMobile = IsSmallScreen()
    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    useEffect(() => {

        const getTask = async () => {
            try {
                if (data) {
                    setValue('notificationId', data?.notificationLogId)
                     setValue('taskName', 'Site Visit')
                    setValue('assignedToUserId', data?.surveyorId)
                    setValue("taskType", "sitevisit")
                }
            }

            catch (e) {

            }
        }
        if (data) {
            getTask();
        }
    }, [data])
    useEffect(() => {

        const getTask = async () => {
            try {

                const response: any = await callAPI(`tasks`, Method.GET, null, taskId);
                if (response.data) {
                    const taskData: any = response.data
                    setValue('taskName', taskData?.taskName)
                    setValue('activityDate', taskData?.activityDate)
                    setValue('activityTime', taskData?.activityTime)
                    setValue('reminder', taskData?.reminder)
                    setValue('taskType', taskData?.taskType)
                    setValue('priority', taskData?.priority)
                    setValue('queue', taskData?.queue)
                    setValue('customDate', dateFormat(taskData?.customDate, 'DD-MM-YYYY'))
                    setValue('notes', taskData?.notes)
                    setValue('reminderSent', taskData?.reminderSent)
                    setValue('customReminderTime', taskData?.customReminderTime)
                    setValue('assignedToUserId', taskData?.assignedToUserId)
                    setIsReminder(taskData?.reminderSent)
                }
            }

            catch (e) {

            }
        }
        if (taskId) {
            getTask();
        }
    }, [taskId])
    const handleActivityChange = (evt: any) => {
        if (evt.target.value !== 'custom') {
            let date = dayjs();
            const val = evt.target.value === 1 ? 0 : evt.target.value === 2 ? 1 : evt.target.value
            date = date.add(Number(val), 'days'); // Assuming value is number of days
            setActivityDate(date.toISOString()); // Converts to ISO 8601 format
        } else {

            setActivityDate(evt.target.value);
        }
    };
    const handleIsReminderSend = (evt: any) => {
        setIsReminder(evt?.target?.checked)
    }
    const source = {
        url: "auth/search",
        page: 1,
        pageSize: 10000000,
        filter: [],
        sort: [],
    };
    const transFormData = (data: any) => {

        const users: Array<any> = []
        data.map((item: any) => {
            users.push({ value: item.id, label: `${item.firstName} ${item.lastName || ""}` })
        })
        return users
    }
    const reduxComponentData = useSelector(
        (state: AppState) => state.components["taskSubmitAss"],
        shallowEqual
    );

    // Local state to store Redux data
    const [componentData, setComponentData] = useState(reduxComponentData);

    // Update useState when Redux state changes
    useEffect(() => {
        if (reduxComponentData) {
            setComponentData(reduxComponentData);
        }
    }, [reduxComponentData]);
    return (
        <Grid >
            {
                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12}>
                        <Typography fontWeight={"bold"} sx={{ fontSize: '.9rem' }}>Task Information</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSTextField
                            label={"Task Name"}
                            {...register("taskName")}
                            id="taskName"
                            name="taskName"
                            control={control}
                            rules={{ required: true }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            options={config.activitySourceConfig.staticOptionData}
                            rules={{ required: true }}
                            {...register("activityDate")}
                            id="activityDate"
                            isMobile={isMobile}
                            control={control}
                            defaultValue={0}
                            onChange={handleActivityChange}
                            label="Activity Date"
                            name="activityDate"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSDateField dateFormat={"DD-MM-YYYY"}
                            label={"Date"}
                            disabled={activityDate !== 'custom'}
                            id="customDate"
                            defaultValue={dateFormat(activityDate, "DD-MM-YYYY")}
                            setValue={setValue}
                            name="customDate"
                            control={control}
                            rules={{ required: false }}

                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSTimePicker
                            id="activityTime"
                            name="activityTime"
                            label={"Activity Time"}
                            control={control}
                            setValue={setValue}
                            rules={{ required: true }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            options={config.taskTypeSourceConfig.staticOptionData}
                            rules={{ required: true }}
                            {...register("taskType")}
                            id="taskType"
                            isMobile={isMobile}
                            control={control}
                            disabled={true}

                            label="Task type"
                            name="taskType"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            options={config.prioritySourceConfig.staticOptionData}
                            rules={{ required: true }}
                            {...register("priority")}
                            id="priority"
                            isMobile={isMobile}
                            control={control}
                            defaultValue={"0"}
                            label="Priority"
                            name="priority"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            options={config.queueSourceConfig.staticOptionData}
                            rules={{ required: true }}
                            {...register("queue")}
                            id="queue"
                            isMobile={isMobile}
                            control={control}
                            defaultValue={"0"}
                            label="Queue"
                            name="queue"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSAutocompleteField
                            source={source}
                            rules={{ required: true }}
                            {...register("assignedToUserId")}
                            transFormData={transFormData}
                            id="assignedToUserId"
                            isMobile={isMobile}
                            control={control}
                            disabled={isDisableUser}
                            label="Assign to User"
                            name="assignedToUserId"
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <WSTextAreaField
                            label={"Notes"}
                            {...register("notes")}
                            id="notes"
                            name="notes"
                            control={control}
                            rules={{ required: false }}
                            rows={2}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <WSSCheckBoxField
                            label="Reminder Send"
                            id="reminderSent"
                            control={control}
                            {...register("reminderSent")}
                            rules={{ required: false }}
                            name="reminderSent"
                            onChange={handleIsReminderSend}
                        />

                        <WSHiddenField control={control} name="taskId" defaultValue={taskId} />
                    </Grid>
                    {isReminder && <><Grid item xs={12} sm={6}>
                        <WSTimePicker
                            id="customReminderTime"
                            name="customReminderTime"
                            label={"Reminder Time"}
                            control={control}
                            setValue={setValue}
                            rules={{ required: false }}
                        />
                    </Grid>
                        <Grid item xs={12} sm={6}>
                            <WSSelectField
                                options={config.reminderSourceConfig.staticOptionData}
                                rules={{ required: false }}
                                {...register("reminder")}
                                id="reminder"
                                isMobile={isMobile}
                                control={control}
                                defaultValue={0}
                                label="Reminder"
                                name="reminder"
                            />
                            <WSHiddenField control={control} name="notificationId" />

                        </Grid></>}


                    <Grid item xs={12} sm={12}>

                        <Divider />
                    </Grid>
                    <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton loading={reduxComponentData?.data?.loading} className="ws-theme-crm" variant="outlined" id='taskSubmitAss' label={"Save"} type="submit" size="medium" />
                        </Grid>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                        </Grid>
                    </Grid>
                </Grid >

            }
        </Grid >
    );
};
export default TaskAssign;
